import { useEffect } from "react";
import { Navigate, Outlet, useParams } from "react-router-dom";
import { DEFAULT_LOCALE, isLocale } from "@/config/site";
import { useI18n } from "@/i18n/I18nContext";
import { NotFoundPage } from "@/pages/NotFoundPage";

/**
 * Validates `:locale`, syncs i18n from the URL, and renders nested routes.
 */
export function LocaleLayout() {
  const { locale: localeParam } = useParams<{ locale: string }>();
  const { setLocale } = useI18n();

  const valid = localeParam != null && isLocale(localeParam);

  useEffect(() => {
    if (valid) setLocale(localeParam);
  }, [localeParam, setLocale, valid]);

  if (!localeParam) {
    return <Navigate to={`/${DEFAULT_LOCALE}`} replace />;
  }

  if (!valid) {
    return <NotFoundPage />;
  }

  return <Outlet />;
}
